import { render } from "./saveData.vue?vue&type=template&id=3edf98a6"
import script from "./saveData.vue?vue&type=script&lang=js"
export * from "./saveData.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__